import { render, staticRenderFns } from "./DarkButton.vue?vue&type=template&id=350cd2eb&scoped=true"
import script from "./DarkButton.vue?vue&type=script&setup=true&lang=js"
export * from "./DarkButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DarkButton.vue?vue&type=style&index=0&id=350cd2eb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350cd2eb",
  null
  
)

export default component.exports